import * as React from "react";
import OdxAreaHeader from "../../../OdxComponents/NativeOdx/Odx-AreaHeader";
import {useMain} from "../../../Utils/SessionControls/mainContext";
import OdxBreadcrumbs from "../../../OdxComponents/NativeOdx/Odx-Breadcrumbs";
import OdxContentBox from "../../../OdxComponents/NativeOdx/Odx-Contentbox";

const ProjectDocumentation: React.FC = () => {

    const {setLoading} = useMain();

    setLoading(false)
    const baseId = 'project-docs';
    return (
        <div id={`${baseId}-view`}>
            <OdxBreadcrumbs id={`${baseId}-breadcrumbs`}/>
            <OdxAreaHeader
                text="Help and About"
                subTitle=""
                odxSize="large"
                className="mb-4"
                id={`${baseId}-header`}
            />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4" id={`${baseId}-grid`}>
                <OdxContentBox title="My Modules" id={`${baseId}-section-my-modules`}>
                    <p>
                        These are your currently active modules for this project. Here you can find IDMS, DOOP, and all
                        other tools in all of their variations, such as Dev & Prod, as well as links to Mobile Stores
                        and other external websites. You can rename and group these at will without affecting
                        functionality.
                    </p>
                </OdxContentBox>
                <OdxContentBox title="Order New Modules" id={`${baseId}-section-order`}>
                    <p>
                        Here you can add new modules, in case you e.g. have another environment that needs IDMS
                        integrations, or a new link to any external website of your choice.
                    </p>
                </OdxContentBox>
                <OdxContentBox title="User Management" id={`${baseId}-section-user-management`}>
                    <p>
                        If you are an admin, configure your team members and their permissions here. You can give them
                        reader (can't change or edit anything, can't see API keys), editor (can add new modules and
                        change or delete existing modules and their data, but has no access to API keys) or admin (full
                        access to everything inside this project) access to the entire project or only certain modules.
                        The more specific one applies. So if someone is editor for the project, but reader for a module,
                        they will be reader within that module and editor everywhere else.
                    </p>
                    <odx-separator style={{margin: '1rem 0'}} />
                    <p>
                        If someone has no access to a project, but does have access to a module within that project,
                        they will automatically receive "reader" access to the project (but not to the other modules).
                    </p>
                </OdxContentBox>
                <OdxContentBox title="API Key Management" id={`${baseId}-section-api-keys`}>
                    <p>
                        The DevSecOps Hub has an integrated Api-Key Service that you can use in any Hub project. Keys
                        can have an (optional) expiration date and always show a timestamp of when they were last used,
                        as well as a non-technical display-Name to tell them apart. They also support multiple keys,
                        allowing you to swap from key 1 to key 2 and then reroll key 1, meaning you can reroll the key
                        without downtime or interruptions.
                    </p>
                    <odx-separator style={{margin: '1rem 0'}} />
                    <h5>Hub Internal Keys</h5>
                    <p>
                        These work the same way that you set up permissions for users inside the Hub. You can give them
                        a global (project-wide) role, but also fine tune them with different roles in different
                        sub-sections of your project.
                    </p>
                    <p>
                        These API keys can then be used to interact with the Hub and all modules inside, to e.g. Read
                        and Update users inside your IDMS module. Check them out in our <a className={'odx-link'}
                                                                                           target={"_blank"}
                                                                                           rel={"noreferrer"}
                                                                                           href={"https://func-devsecopshub-prod.azurewebsites.net/api/swagger#/ListApiKeys/RunListAsync"}>Hub
                        API Docs</a> .
                    </p>
                    <odx-separator style={{margin: '1rem 0'}} />
                    <h5>Custom Keys for your own APIs</h5>
                    <p>
                        You created your own API in your own app and need a system for authorization with different
                        permissions per API Key? Then these custom keys are the right tool for you. When creating one,
                        you can specify their content in a freeform textfield. It can be a simple string, or JSON in the
                        structure of your choosing, or YAML, or anything else. Users can then send this Key to your API
                        and you "resolve" it using a public Hub API to receive the content you specified before.
                    </p>
                </OdxContentBox>
                <OdxContentBox title="Logs" id={`${baseId}-section-logs`}>
                    <p>
                        All related logs to all your ordered modules and the hub project itself can be found here.
                    </p>
                </OdxContentBox>
                <OdxContentBox title="Project Information" id={`${baseId}-section-info`}>
                    <p>
                        Place all important info for your hub project here, such as cost center, contact person,
                        description, etc.
                    </p>
                </OdxContentBox>
            </div>
        </div>
    );
};

export default ProjectDocumentation;
